<template>
    <div class="password-field">
        <div class="password-control">
            <input
                :type="passwordFieldType"
                v-model="password"
                :id="id"
                :data-test-id="dataTestId"
                @focus="inputFocus = true"
                @blur="inputFocus = false"
                class="form-control"
                :class="{ 'is-invalid': !passwordsMatch }"
                autocomplete="new-password"
                :required="required" />
            <button type="button" class="password-toggle" :aria-label="toggleLabel" :title="toggleLabel" @click="switchVisibility">
                <feather class="feather-18" :type="featherIcon" />
            </button>
        </div>
        <div class="div-pass-check password-confirmation-feedback" v-show="showLegend_">
            <span v-show="!passwordsMatch" class="password-rule is-missing"> <feather type="circle" />{{ $t("labels.password.mismatch") }} </span>
            <span v-show="passwordsMatch && mainPassword && password" class="password-rule is-valid">
                <feather type="check" />{{ $t("labels.password.match") }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            inputFocus: false,
            passwordFieldType: "password",
            featherIcon: "eye",
        };
    },
    props: {
        id: {
            type: String,
            default: undefined,
        },
        mainPassword: {
            default: null,
        },
        value: {
            default: null,
        },
        showLegend: {
            default: false,
        },
        hideLegend: {
            default: false,
        },
        dataTestId: {
            type: String,
            default: undefined,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        passwordsMatch() {
            if (!this.mainPassword || !this.password) return true;
            return this.mainPassword === this.password;
        },
        showLegend_() {
            return !this.hideLegend && this.password !== "" && (this.showLegend || this.inputFocus);
        },
        toggleLabel() {
            return this.passwordFieldType === "password" ? this.$t("labels.password.show") : this.$t("labels.password.hide");
        },
        password: {
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit("input", newVal);
            },
        },
    },
    methods: {
        switchVisibility() {
            this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
            this.featherIcon = this.featherIcon === "eye" ? "eye-off" : "eye";
        },
    },
};
</script>

<style lang="scss" scoped>
.password-field {
    position: relative;
    width: 100%;
}

.password-field.has-floating-help {
    z-index: 30;
}

.password-control {
    position: relative;
}

.password-control .form-control {
    padding-right: 50px;
}

.password-control .form-control.is-invalid {
    padding-right: 86px;
    background-position: right 48px center;
}

.password-toggle {
    position: absolute;
    top: 50%;
    right: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    color: #083e60;
    background: transparent;
    border: 0;
    border-radius: 8px;
    cursor: pointer;
    transform: translateY(-50%);
    transition: color 0.18s ease, background-color 0.18s ease;
}

.password-toggle:hover,
.password-toggle:focus {
    color: #052a43;
    background-color: rgba(8, 62, 96, 0.08);
    outline: none;
}
</style>
